import {useParams} from 'react-router';

import {useExperimentsStore} from 'apps/experiments/src/store';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {useCurrentProject} from 'common/contexts/react/current-project-context';
import {ProjectFeatureFlag} from 'common/report/constants';

export function useExperimentPageContext() {
  const {experimentId} = useParams<{experimentId: string}>();
  const projectId = parseInt(getProjectId(), 10);
  const workspaceId = parseInt(getWorkspaceId(), 10);
  const userId = userCookieUtils.getUserIdentityFromCookie()?.id ?? 0;
  const currentProject = useCurrentProject().get().value;
  const featureFlagIntegrationEnabled = currentProject?.hasFeatureFlag(ProjectFeatureFlag.FeatureFlagsApp) || false;

  const segmentFilterController = useExperimentsStore((state) => state.segmentFilterController);

  return {
    experimentId,
    projectId,
    workspaceId,
    userId,
    currentProject,
    featureFlagIntegrationEnabled,
    segmentFilterController,
  };
}
